import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Request } from '../models/request.model';
import { NewRequest } from '../models/new-request.model';
import { SearchParams } from '../models/serach-params.model';
import { ResultFile } from '../models/result-file.model';
import { GdprRequestActionViewModel } from '../models/gdpr-request-action-view-model.dto';
import { InitializationService } from './initialization.service';
import { environment } from '@environment';

@Injectable()
export class RequestService {
    constructor(
        private httpClient: HttpClient,
        private initializationService: InitializationService,
    ) {}

    addRequest(request: NewRequest): Observable<Request> {
        return this.httpClient.post<Request>(
            environment.apiInboxUrl +
                'Community/GdprPortals/' +
                +this.initializationService.portal.id +
                '/PersonalDataRequests/',
            request,
        );
    }

    addResultFileTask(requestId: number): Observable<ResultFile> {
        return this.httpClient.post<ResultFile>(
            environment.apiInboxUrl +
                'Community/GdprPortals/' +
                +this.initializationService.portal.id +
                '/PersonalDataRequests/' +
                requestId +
                '/ResultFilesGenerator/Task',
            {},
        );
    }

    getRequest(id: number): Observable<Request> {
        return this.httpClient.get<Request>(
            environment.apiInboxUrl +
                'Community/GdprPortals/' +
                +this.initializationService.portal.id +
                '/PersonalDataRequests/' +
                id +
                '/',
        );
    }

    getRequestLog(id: number, skip: number, take: number): Observable<GdprRequestActionViewModel[]> {
        return this.httpClient.get<GdprRequestActionViewModel[]>(
            environment.apiInboxUrl +
                'Community/GdprPortals/' +
                +this.initializationService.portal.id +
                '/PersonalDataRequests/' +
                id +
                '/logs?skip=' +
                skip +
                '&take=' +
                take,
        );
    }

    getRequests(searchParams: SearchParams): Observable<Request[]> {
        return this.httpClient.get<Request[]>(
            environment.apiInboxUrl +
                'Community/GdprPortals/' +
                +this.initializationService.portal.id +
                '/PersonalDataRequests/',
            {
                params: new HttpParams()
                    .set('requestStatus', searchParams.requestStatus)
                    .set('resultFileStatus', searchParams.resultFileStatus)
                    .set('isLinkExpired', searchParams.isLinkExpired.toString())
                    .set('query', searchParams.query)
                    .set('skip', searchParams.skip.toString())
                    .set('take', searchParams.take.toString()),
            },
        );
    }

    getPreviewFile(requestId: number, fileId: number): Observable<string> {
        return this.httpClient.get<string>(
            environment.apiInboxUrl +
                'Community/GdprPortals/' +
                +this.initializationService.portal.id +
                '/PersonalDataRequests/' +
                requestId +
                '/ResultFiles/' +
                fileId +
                '/Html',
        );
    }

    updateRequestStatus(id: number, isArchived: boolean): Observable<Request> {
        return this.httpClient.put<Request>(
            environment.apiInboxUrl +
                'Community/GdprPortals/' +
                +this.initializationService.portal.id +
                '/PersonalDataRequests/' +
                id +
                '/IsArchived',
            isArchived,
            {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                }),
            },
        );
    }
}
